import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { PERIODS_ACTIONS, PERIODS_TYPES } from "./actions";
import {
  getPeriod as APIgetPeriod,
  getPeriods as APIgetPeriods,
  createPeriod as APIcreatePeriod,
  updatePeriod as APIupdatePeriod,
  deletePeriod as APIdeletePeriod
} from "../../services/api/periods";
import { periodFilters } from "./selectors";
import { selectEvent } from "../preferences/selectors";
import { EVENT_MATERIALS_TYPES } from '../eventMaterials/actions'

export function* watchPeriodsActions() {
  yield all([takeEvery(PERIODS_TYPES.LOAD_REQUEST, getPeriod)]);
  yield all([takeEvery(PERIODS_TYPES.CREATE_REQUEST, createPeriod)]);
  yield all([takeEvery(PERIODS_TYPES.UPDATE_REQUEST, updatePeriod)]);
  yield all([takeEvery(PERIODS_TYPES.DELETE_REQUEST, deletePeriod)]);
  yield all([
    takeEvery(
      [
        PERIODS_TYPES.LOAD_ALL_REQUEST,
        PERIODS_TYPES.UPDATE_SUCCESS,
        PERIODS_TYPES.CREATE_SUCCESS,
        PERIODS_TYPES.DELETE_SUCCESS
      ],
      getPeriods
    )
  ]);
}

function* getPeriods(action) {
  let { filters } = action.payload;
  const eventId = yield call(getEventIdFromAction, action);

  try {
    if (!filters) {
      filters = yield select(periodFilters);
    } else {
      yield put(PERIODS_ACTIONS.updateFilters(eventId));
    }

    const periods = yield call(APIgetPeriods, eventId, filters);
    yield put(PERIODS_ACTIONS.loadAllSuccess(periods));
  } catch (e) {
    yield put(PERIODS_ACTIONS.loadAllFailure(e));
  }
}

function* getPeriod(action) {
  const { id } = action.payload;
  const eventId = yield call(getEventIdFromAction, action);

  try {
    const period = yield call(APIgetPeriod, eventId, id);
    yield put(PERIODS_ACTIONS.loadSuccess(period));
  } catch (e) {
    yield put(PERIODS_ACTIONS.loadFailure(e));
  }
}

function* createPeriod(action) {
  const { values } = action.payload;
  const eventId = yield call(getEventIdFromAction, action);

  try {
    const period = yield call(APIcreatePeriod, eventId, values);
    yield put(PERIODS_ACTIONS.createSuccess(period));
  } catch (e) {
    yield put(PERIODS_ACTIONS.createFailure(e));
  }
}

function* updatePeriod(action) {
  const { id, values } = action.payload;
  const eventId = yield call(getEventIdFromAction, action);

  try {
    const period = yield call(APIupdatePeriod, eventId, id, values);
    yield put(PERIODS_ACTIONS.updateSuccess(period));
  } catch (e) {
    yield put(PERIODS_ACTIONS.updateFailure(e));
  }
}

function* deletePeriod(action) {
  const { id } = action.payload;
  const eventId = yield call(getEventIdFromAction, action);

  try {
    const period = yield call(APIdeletePeriod, eventId, id);
    yield put(PERIODS_ACTIONS.deleteSuccess(period));
  } catch (e) {
    yield put(PERIODS_ACTIONS.deleteFailure(e));
  }
}

function* getEventIdFromAction(action) {
  let { eventId } = action.payload;
  if (!eventId) {
    const event = yield select(selectEvent);
    eventId = event.id;
  }

  return eventId;
}
